import { useQueryClient } from '@tanstack/react-query';
import { useNavigate } from 'react-router-dom';
import type { Me } from '../api/types';
import { useServices } from '../services';

const SITE_URL = import.meta.env.VITE_SITE_URL || 'https://demandpilot.novamind.nz';

/** Shown when a free trial has ended or a subscription is cancelled. Nothing is deleted. */
export function TrialEndedPage({ me }: { me: Me }) {
  const { auth } = useServices();
  const qc = useQueryClient();
  const navigate = useNavigate();
  const cancelled = me.subscription?.status === 'cancelled';
  return (
    <div className="auth-page">
      <div className="auth-card">
        <div className="wordmark" aria-label="DemandPilot">Demand<span>Pilot</span></div>
        <h1 style={{ fontSize: 24, marginBottom: 6 }}>{cancelled ? 'Your subscription has ended' : 'Your free trial has ended'}</h1>
        <p className="muted">
          {me.tenant.name}’s sales history, settings and forecasts are kept safe. Overnight forecasts and emails are paused
          until you choose a plan.
        </p>
        <div style={{ display: 'grid', gap: 10, marginTop: 18 }}>
          <a className="btn btn-primary" href="mailto:hello@novamind.nz?subject=DemandPilot%20subscription">Choose a plan</a>
          <a className="btn" href={`${SITE_URL}/pricing.html`} target="_blank" rel="noreferrer">See pricing</a>
          <button type="button" className="link-btn" onClick={async () => { await auth.signOut(); qc.clear(); navigate('/sign-in'); }}>
            Sign out
          </button>
        </div>
        <p className="muted small" style={{ marginTop: 16, marginBottom: 0 }}>Want your data deleted instead? Email hello@novamind.nz.</p>
      </div>
    </div>
  );
}
